<template>
    <div class="index-main">
        <header-bar tab-index="0"/>

        <div id="myCarousel" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
                <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
                <li data-target="#myCarousel" data-slide-to="1"></li>
                <li data-target="#myCarousel" data-slide-to="2"></li>
            </ol>
            <div class="carousel-inner">
                <div class="active item"><img src="../../resource/img/index/1.jpg"></div>
                <div class="item"><img src="../../resource/img/index/2.jpg"></div>
                <div class="item"><img src="../../resource/img/index/3.jpg"></div>
            </div>
        </div>

        <product-panel/>
        <service-panel/>
        <case-panel/>
        <tech-panel/>
        <about-panel/>

        <side-bar/>
        <footer-bar/>
    </div>
</template>
<script>
import HeaderBar from '../../components/header';
import FooterBar from '../../components/footer';
import SideBar from '../../components/sider';
import ProductPanel from '../../components/index/product';
import ServicePanel from '../../components/index/service';
import CasePanel from '../../components/index/case';
import TechPanel from '../../components/index/technology';
import AboutPanel from '../../components/index/about';
import '../../resource/css/common.css';

export default {
    name: "index",
    components: {
        'header-bar': HeaderBar,
        'footer-bar': FooterBar,
        'side-bar': SideBar,
        'product-panel': ProductPanel,
        'service-panel': ServicePanel,
        'case-panel': CasePanel,
        'tech-panel': TechPanel,
        'about-panel': AboutPanel,
    },
    data() {
        return {
        }
    },
    created() {
        $('.carousel').carousel();
    },

}
</script>
<style>
.index-main {
  position: relative;
}

.carousel-indicators {
    bottom: 20px;
}

.carousel-indicators li {
    margin: 0 4px;
    border: 0;
    background-color: rgba(102, 116, 161, 0.2);
    width: 12px;
    height: 12px;
}

.carousel-indicators .active {
    background-color: #b3bad0;
}
</style>
